import Send from '../../send';

import {Search} from "../../../model/search";

const DEFAULT_API = '/v1/visitor-blacklist';
export default {


    getVisitorBlacklist(hostInfoNumber) {
        return Send({
            url : `${DEFAULT_API}/blacklist`,
            method : 'GET',
            params : {
                hostInfoNumber : hostInfoNumber
            }
        });
    },

    getVisitorBlacklistBySearchAndPage(hostInfoNumber, searchInfo : Search, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/blacklist?page=${pageNumber}`,
            method : 'GET',
            params : {
                hostInfoNumber : hostInfoNumber,
                searchValue : searchInfo.searchValue,
                visitorBlacklistSearchType : searchInfo.searchType
            }
        });
    },


    createVisitorBlacklist(
        hostInfoNumber,
        visitorName,
        visitorPhone,
        blockStartDate,
        blockEndDate,
        blockReason) {
        return Send({
            url : `${DEFAULT_API}/createVisitorBlacklist`,
            method : 'POST',
            params : {
                hostInfoNumber : hostInfoNumber,
                visitorName : visitorName,
                visitorPhone : visitorPhone,
                blockStartDate: blockStartDate,
                blockEndDate: blockEndDate,
                blockReason : blockReason
            }
        });
    },


    updateBlacklistStatus(data, hostInfo) {
        return Send({
            url : `${DEFAULT_API}/updateBlacklistStatus`,
            method : 'PUT',
            params : {
                seq : data.seq,
                hostNumber : hostInfo.number,
                blockType : data.blockType
            }
        });
    }
}